export default "__VITE_ASSET__DgmFoGMs__"